import React, { useEffect, useState } from 'react';
import { Pantallas } from '../services/api';
import { LabeledInput } from './ui';

export default function GroupDesignEditor({ group, onSaved }) {
  const [nombre, setNombre] = useState(group?.nombre || '');
  const [logo, setLogo] = useState(group?.diseno?.logo || '');
  const [fecha, setFecha] = useState(!!group?.diseno?.fecha);
  const [reloj, setReloj] = useState(!!group?.diseno?.reloj);
  const [styleText, setStyleText] = useState(() => {
    try { return JSON.stringify(group?.diseno?.style || {}, null, 2); } catch { return '{}'; }
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setNombre(group?.nombre || '');
    setLogo(group?.diseno?.logo || '');
    setFecha(!!group?.diseno?.fecha);
    setReloj(!!group?.diseno?.reloj);
    setStyleText(() => {
      try { return JSON.stringify(group?.diseno?.style || {}, null, 2); } catch { return '{}'; }
    });
  }, [group?._id]);

  const beautify = () => {
    try { setStyleText(JSON.stringify(JSON.parse(styleText || '{}'), null, 2)); } catch {}
  };

  const save = async () => {
    let styleObj = {};
    try { styleObj = styleText ? JSON.parse(styleText) : {}; }
    catch { alert('El campo "style" no es un JSON válido.'); return; }

    try {
      setBusy(true);
      await Pantallas.patchGroup(group._id, { nombre, diseno: { logo, fecha, reloj, style: styleObj } });
      onSaved?.();
    } catch (e) {
      console.error(e); alert(e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="grid gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <LabeledInput label="Nombre del grupo" value={nombre} onChange={e => setNombre(e.target.value)} />
        <LabeledInput label="Logo (URL)" value={logo} onChange={e => setLogo(e.target.value)} placeholder="https://cdn.example.com/logo.png" />
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={fecha} onChange={e => setFecha(e.target.checked)} /> Mostrar fecha
        </label>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={reloj} onChange={e => setReloj(e.target.checked)} /> Mostrar reloj
        </label>
      </div>

      <label className="grid gap-1">
        <span className="text-sm text-white/70">style (JSON)</span>
        <textarea
          value={styleText}
          onChange={e => setStyleText(e.target.value)}
          rows={8}
          className="rounded-xl bg-white/5 border border-white/10 text-white px-3 py-2 font-mono text-sm"
          placeholder='{"colorPrimario":"#004b4b"}'
        />
        <div className="flex gap-2 justify-end mt-1">
          <button onClick={beautify} className="rounded-xl bg-slate-700 hover:bg-slate-600 px-3 py-2 text-sm">Formatear JSON</button>
          <button disabled={busy} onClick={save} className="rounded-xl bg-indigo-600 hover:bg-indigo-500 px-3 py-2 text-sm disabled:opacity-60">Guardar cambios</button>
        </div>
      </label>
    </div>
  );
}
